import { render, staticRenderFns } from "./Love.vue?vue&type=template&id=fe398be6&scoped=true"
import script from "./Love.vue?vue&type=script&lang=js"
export * from "./Love.vue?vue&type=script&lang=js"
import style0 from "./Love.vue?vue&type=style&index=0&id=fe398be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe398be6",
  null
  
)

export default component.exports